import { burnishedSilver, eastBayBlue, mercury, transparentGray, white } from 'web-ui-kit/colors';
import { css } from 'styled-components';

// Padding between sections
export const SECTION_PADDING = 24;
// Padding between cells and between cells and title
export const CELL_PADDING = 8;
// Width of border and strikethrough line
export const BORDER_WIDTH = 1;
// Size of image variant cells
export const IMAGE_CELL_SIZE = 40;

export const VariantSelectionState = {
  DEFAULT: 'default',
  DISABLED: 'disabled',
  SELECTED: 'selected',
  OUT_OF_STOCK: 'out_of_stock',
  OUT_OF_STOCK_SELECTED: 'out_of_stock/selected'
};

export const UserFacingCopy = {
  SectionTitle: {
    'color': 'Color',
    'dimensions': 'Size'
  }
};

export const getBorderColorForState = (state) => {
  switch (state) {
    case VariantSelectionState.SELECTED:
    case VariantSelectionState.OUT_OF_STOCK_SELECTED:
      return eastBayBlue;
    case VariantSelectionState.DISABLED:
    case VariantSelectionState.OUT_OF_STOCK:
      return burnishedSilver;
    default:
      return mercury;
  }
};

export const HOVER_CSS = css`
  @media (hover: hover) {
    &:hover {
      border: none;
      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    }
  }
`;

const stateHasHover = (state) => {
  switch (state) {
    case VariantSelectionState.DISABLED:
    case VariantSelectionState.SELECTED:
    case VariantSelectionState.OUT_OF_STOCK_SELECTED:
      return false;
    default:
      return true;
  }
};

export const getCSSForState = (state) => {
  let stateCSS = '';
  switch (state) {
    case VariantSelectionState.DISABLED:
      stateCSS = `
        border: ${BORDER_WIDTH}px solid ${getBorderColorForState(state)};
        background: ${transparentGray};
        color: ${white};
        cursor: default;
        `;
      break;
    default:
      stateCSS = `
        border: ${BORDER_WIDTH}px solid ${getBorderColorForState(state)};
        `;
      break;
  }
  return `
  ${stateCSS}
  ${stateHasHover(state) && HOVER_CSS}
  `;
};
